import { Component } from '@angular/core';
import {SignupService} from "../../../services/signup.service";

@Component({
  selector: 'app-merchant-reviewing-account',
  templateUrl: './merchant-reviewing-account.component.html',
  styleUrls: ['./merchant-reviewing-account.component.css']
})
export class MerchantReviewingAccountComponent {

  constructor(private signupService: SignupService) {  }
  ngOnInit() {
    this.signupService.currentStepBs.next(this.signupService.Step.REVIEWING_ACCOUNT);
    this.signupService.disableBackButton = false
    this.signupService.disableNextButton = true
  }
}
